<template>
    <div v-if="showElements" class="pt-2 pb-2">
        <p v-if="beforeRegistrationWindow">Registration opens {{ startDateForDisplay }}.</p>
        <button v-if="duringRegistrationWindow" class="btn btn-outline-primary" type="button" ref="buttonElement" @click="buttonClickHandler" />
        <p v-if="afterRegistrationWindow">Registration has closed.</p>
    </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
    name: 'RegistrationButton',

    data() {
        return {
            afterRegistrationWindow: false,
            beforeRegistratinWindwo: false,
            duringRegistrationWindow: false,
            showElements: false,
            startDateForDisplay: '',
        }
    },

    methods: {
        buttonClickHandler() {
            window.open(this.event.registration_url, '_blank')
        },
    },

    mounted() {
        this.showElements = this.event.registration_start_date && this.event.registration_end_date && this.event.registration_url
        if (this.showElements) {
            const now = dayjs()
            const registrationEnd = dayjs(this.event.registration_end_date)
            const registrationStart = dayjs(this.event.registration_start_date)
            this.afterRegistrationWindow = now > registrationEnd
            this.beforeRegistrationWindow = now < registrationStart
            if (this.beforeRegistrationWindow) {
                this.startDateForDisplay = registrationStart.format('MMMM D')
            }
            this.duringRegistrationWindow = now >= registrationStart && now <= registrationEnd
            this.$nextTick(() => {
                if (this.$refs.buttonElement) {
                    this.$refs.buttonElement.innerHTML = this.buttonText
                }
            })
        }
    },

    props: {
        event: {
            type: Object,
            required: true,
        },
        buttonText: {
            type: String,
            default: 'Register',
        },
    },
}
</script>

<style scoped>
p {
    font-weight: bold;
}
</style>